import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';
import { TabulationClassification, TabulationDatum } from '@rds/rds-base-ts';

import { DatumCell } from './datum-cell.model';
import { getDatumValue } from './datum-util';

export class TableDimension {
  /** Datum table cells */
  datumCellValues: Array<DatumCell> = [];
  /** Whether Dimension has a more than one datum. If there is only one, we don't show the subtotal */
  hasMultipleDatum?: boolean;
  /** Unique identifiers for each header cell created with this variable */
  headerIds: Array<string> = [];
  /** Display value for the variable */
  name: string;

  /** `colspan` or `rowspan` for the name cell */
  nameCellSpan: { [headerId: string]: number } = {};

  /**
   * @param variable Dimension's variable
   * @param data Variable's unique datum
   * @param parentDimension Dimension's parent
   */
  constructor(
    public variable: Variable | VariableSummary | null,
    data: TabulationDatum[],
    parentDimension: TableDimension,
    hasSubtotal: boolean,
    classifications: { [id: string]: TabulationClassification },
    cellspan?: number
  ) {
    this.hasMultipleDatum = data.length > 1;
    this.name = variable?.label || variable?.name || '';
    const parentCells: DatumCell[] = parentDimension ? parentDimension.datumCellValues : [new DatumCell([], false, '')];
    parentCells.forEach((parent) => {
      if (!parent.subtotal) {
        // for each parent cellValue, create an iteration of all current dim's datum
        this.headerIds.push(`${parent.id + this.name}`);
        this.datumCellValues.push(
          ...data.map((datum) => {
            const id = parent.id + datum.v + getDatumValue(datum, [variable], classifications);
            return new DatumCell(parent.datumStack.concat(datum), false, id);
          })
        );
        if (!!parentDimension && this.hasMultipleDatum && hasSubtotal) {
          this.datumCellValues.push(new DatumCell(parent.datumStack, true, parent.id + 'subtotal', cellspan));
        }
      }
    });
  }
}
